import script from "./FormComponentsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormComponentsBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormComponentsBlock.vue?vue&type=style&index=0&id=243242e1&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243242e1"]])

export default __exports__